import { render } from "./AppSwitch.vue?vue&type=template&id=335c83b0"
import script from "./AppSwitch.vue?vue&type=script&lang=js"
export * from "./AppSwitch.vue?vue&type=script&lang=js"

import "./AppSwitch.vue?vue&type=style&index=0&id=335c83b0&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__